import { render } from "./dettagli.vue?vue&type=template&id=ae2f18dc&scoped=true&bindings={\"navigate\":\"props\"}"
import script from "./dettagli.vue?vue&type=script&lang=js"
export * from "./dettagli.vue?vue&type=script&lang=js"

import "./dettagli.vue?vue&type=style&index=0&id=ae2f18dc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ae2f18dc"
/* custom blocks */
import block0 from "./dettagli.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(script)


export default script